import React, { useState, useRef, useEffect } from "react";
import { Card } from "reactstrap";
import { Plus, PlusCircle, Search, SearchIcon } from "lucide-react";
import CommonTable from "../CommonTable";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import CreateLab from "./CreateLab";
import AddPatient from "../SearchPatient/AddPatient";
import Swal from "sweetalert2";
import { useLoader } from "../../_helper/LoaderContext";
import { useNavigate } from "react-router";
import { deletePatient, getPatientList, statusPatient } from "./service/patient-service";
import { toast } from "react-toastify";
import { stateMaster } from "../LabProfile/service/profile-service";


const PatinetHome = () => {
    const [show, setShow] = useState(false);
    const [users, setUsers] = useState([]);

    const [data, setData] = useState({})
    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [entriesPerPage, setEntriesPerPage] = useState(10);
    const [totalEntries, setTotalEntries] = useState(0);
    const { setLoading } = useLoader();
    const navigate = useNavigate();
    const [gender, setGender] = useState("all");
    const [states, setStates] = useState("all");

    useEffect(() => {
        getList()
    }, [currentPage, entriesPerPage, search, gender])

    const getList = async () => {
        setLoading(true)
        try {
            const form_data = new FormData()
            form_data.append("search", search);
            form_data.append("page", currentPage);
            form_data.append("limit", entriesPerPage);
            form_data.append("gender", gender);
            const res = await getPatientList(form_data)
            // console.log(res)
            if (res.data.success == true) {
                const filterData = res.data.data.patients.map((item) => ({
                    uniqueId: item.uniqueId,
                    name: item.fname,
                    age: item.age,
                    gender: item.gender,
                    email: item.email,
                    contact: item.contact,
                    isActive: item.isActive,
                    _id: item._id,
                    address: item.address,
                    state: item.state
                }))
                setUsers(filterData)
                setTotalEntries(res.data.data.pagination.total || 0);
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    const columns = [
        { header: "Customer ID", accessor: "uniqueId", width: '120px' },
        { header: "Name", accessor: "name", width: '200px' },
        { header: "Email", accessor: "email", width: '220px' },
        {
            header: "Contact",
            accessor: "contact",
            width: '150px',
            render: (value) => {
                if (!value) return "-";
                // Add + sign and format cleanly
                return <strong>+{value}</strong>;
            }
        },
        { header: "Age", accessor: "age", width: '50px' },
        { header: "Gender", accessor: "gender", width: '100px' },
    ];

    const handleClose = () => {
        setShow(false);
    }

    const handleToggleStatus = (data) => {
        Swal.fire({
            title: "Are you sure?",
            text: data.isActive
                ? "You want to inactivate this patinet?"
                : "You want to activate this patinet?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: `${data.isActive == true ? "Inactive" : "Active"}`
        }).then(async (result) => {
            if (result.isConfirmed) {
                setLoading(true)
                try {
                    const res = await statusPatient(data._id)
                    if (res.data.success == true) {
                        toast.success(res.data.message)
                        getList()
                    }
                } catch (error) {
                    console.log(error)
                } finally {
                    setLoading(false)
                }
            }
        });
    };

    const totalPages = Math.ceil(totalEntries / entriesPerPage);

    const actions = [
        // { label: "View", onClick: (row) => handleEdit(row) },
        { label: "Edit", onClick: (row) => handleEdit(row) },
        { label: "Delete", onClick: (row) => detele(row) },
    ];

    const handleEdit = (user) => {
        // alert(`Edit user: ${user.name}`);
        setShow(true)
        setData(user)
    };

    const handleShow = () => {
        setData({})
        setShow(true);
    }

    const detele = (data) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You want to delete this patinet?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: `Yes, delete it!`
        }).then(async (result) => {
            if (result.isConfirmed) {
                setLoading(true)
                try {
                    const res = await deletePatient(data._id)
                    if (res.data.success == true) {
                        toast.success(res.data.message)
                        getList()
                    }
                } catch (error) {
                    console.log(error)
                } finally {
                    setLoading(false)
                }
            }
        });
    };

    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            getList();
        }, 500); // waits 0.5s after typing stops

        return () => clearTimeout(delayDebounce);
    }, [search, currentPage, entriesPerPage]);

    useEffect(() => {
        fetchStates()
    }, [])

    const fetchStates = async () => {
        setLoading(true)
        try {
            const res = await stateMaster({ country: "India" });
            if (res.data.success == true) {
                setStates(res.data.data);
                // setStatesLoaded(true);
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    };

    return (
        <>
            <Card>
                <div className="p-3 mt-4">
                    <div className="row mb-2">
                        <div className="col-md-6">
                            <div className="input-group mb-3 ">
                                <span className="input-group-text tw-bg-white" id="basic-addon1"><SearchIcon /></span>
                                <input type="text" className="form-control icon_form" placeholder="Search by Name / Email..." aria-label="Username" aria-describedby="basic-addon1" style={{ borderLeft: 'none' }} value={search}
                                    onChange={(e) => setSearch(e.target.value)} />
                            </div>
                        </div>
                        <div className="col-md-2">
                            <select
                                className="form-select"
                                value={gender}
                                onChange={(e) => setGender(e.target.value)}
                            >
                                <option value="all">ALL</option>
                                <option value="male">Male</option>
                                <option value="female">Female</option>
                                <option value="other">Other</option>
                            </select>
                        </div>
                        <div className="col-md-4 text-end">
                            <Button variant="primary" onClick={handleShow}>
                                Add
                            </Button>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <CommonTable
                                columns={columns}
                                data={users}
                                onToggleStatus={handleToggleStatus}
                                onAction={actions}
                                totalPages={totalPages}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                entriesPerPage={entriesPerPage}   // pass value
                                setEntriesPerPage={setEntriesPerPage}  // pass setter
                            />
                        </div>
                    </div>
                </div>
            </Card>
            <Modal show={show} onHide={handleClose}>
                <AddPatient setUploadModelOpen={handleClose} toggleUploadModel={handleClose} data={data} getList={getList} />
            </Modal>

        </>
    );
};

export default PatinetHome;
